namespace TR {

    export class DealsBoxService {

        hotelInfoBackTracked: boolean;
        singleEditTrack: any;


        constructor(
            private $filter: any,
            private holidayDeals: any,
            private dateUtil: any,
            private hotelFromSession: any,
            private occupancyService: any,
            private analytics: any
        ) {
            this.hotelInfoBackTracked = false;
            this.singleEditTrack = {};
        }

        enrichSelected(selected) {
            return this.holidayDeals
                .getCurrentFilters()
                .then(f => {
                    let boardTypeFilter = f.BoardTypes.map(bt => parseInt(bt, 10));
                    return _.first(this.holidayDeals.enrichDeals([selected], boardTypeFilter));
                });
        }

        getDealsForCalendar(estabId, duration, dates, selectedDate) {
            let boardTypeFilter;
            return this.holidayDeals
                .getCurrentFilters()
                .then(f => {
                    boardTypeFilter = f.BoardTypes.map(bt => parseInt(bt, 10));
                    return this.holidayDeals.getDealsForHotel(estabId, [duration], dates);
                })
                .then(h => {
                    return h && h.HolidayDeals
                        ? this.holidayDeals.enrichDeals(h.HolidayDeals, boardTypeFilter)
                        : [];
                });
        }

        getTransfersMap(transferTimes) {
            if (!transferTimes) { return; }
            return transferTimes.reduce(
                (p, c) => {
                    p[c.Airport] = c.Minutes;
                    return p;
                }, {});
        }

        getRoomsForDeal(estabId, searchId, oldRoom, oldBoardType, persist) {
            let boardTypeFilter;
            return this.holidayDeals
                .getCurrentFilters()
                .then(f => {
                    boardTypeFilter = f.BoardTypes.map(bt => parseInt(bt, 10));
                    return this.hotelFromSession.getRoomTypes(estabId, searchId, boardTypeFilter);
                })
                .then(r => {
                    const dealsRooms: any = {};
                    dealsRooms.rooms = (r || r.length) ? this._sortRoomsByPrice(r) : [];
                    if (r.length) {
                        dealsRooms.best = this._pickBestRoom(
                            dealsRooms.rooms,
                            boardTypeFilter,
                            oldRoom,
                            oldBoardType,
                            persist
                        );
                    }
                    return dealsRooms;
                });
        }

        updatePriceLabels(rooms, selectedRoomId, currentBoardTypes, selectedBt, priceMode) {
            const updatedBoardTypes = currentBoardTypes.map(bt => {
                const { diff, label } = this._calcDifference(bt.Cost, selectedBt.Cost, priceMode);
                bt.NamePrice = diff === 0
                    ? bt.BoardDescription
                    : `${bt.BoardDescription} (${diff < 0 ? '-' : '+'}${label})`;
                return bt;
            });

            const updatedRooms = rooms.map(r => {
                const current =
                    _.find(r.BoardOptions, (bt: any) => bt.BoardType === selectedBt.BoardType);
                const boardCost = current ? current.Cost : r.BoardOptions[0].Cost;
                const { diff, label } = this._calcDifference(boardCost, selectedBt.Cost, priceMode);
                r.PriceDiffLabel = `${diff < 0 ? '-' : '+'}${label}`;
                r.NamePrice = diff === 0 || r.MasterId === selectedRoomId
                    ? r.RoomDescription
                    : `${r.RoomDescription} (${r.PriceDiffLabel})`;

                return r;
            });

            return { updatedBoardTypes, updatedRooms };
        }

        findTemperature(selectedDate, temperatures) {
            if (!selectedDate || !temperatures) { return 0; }

            const weather = _.find(
                temperatures,
                (t: any) => t.Month === (selectedDate.getMonth() + 1)
            );
            return weather ? Math.round(weather.Temperature) : 0;
        }

        getTabCounter(entryPoint: string) {
            const tracking = { entryPoint };
            return (tab) => {
                if (!tab) { return tracking; }
                tracking[tab] = _.has(tracking, tab) ? tracking[tab] + 1 : 1;
                return tracking;
            };
        }

        sendTabTracking(tabsStat) {
            if (!tabsStat || !_.has(tabsStat, 'entryPoint')) { return; }
            this.analytics.track(
                'mixpanel',
                'HolidayDealsHotelDetails',
                tabsStat
            );
        }

        trackHotelInfoBack() {
            if (!this.hotelInfoBackTracked) {
                this.analytics.track(
                    'mixpanel',
                    'HolidayDealsHotelDetailsBack'
                );
                this.hotelInfoBackTracked = true;
            }
        }

        trackOpenBox(hotel, dealsNumber, dealsMiss) {
            this.hotelInfoBackTracked = false;
            this.singleEditTrack = {};
            this.analytics.track(
                'mixpanel',
                'HolidayDealsDetails',
                {
                    EstabId: hotel.Id,
                    EstabName: hotel.Title,
                    ProvinceId: hotel.ProvinceId,
                    Province: hotel.Province,
                    CountryId: hotel.CountryId,
                    Country: hotel.Country,
                    StarRating: hotel.StarRating,
                    DealsOnCalendar: dealsNumber,
                    DealsMiss: dealsMiss
                }
            );
        }

        trackDateChange(newDeal, oldDeal) {
            if (!oldDeal || !oldDeal.Price) { return; }
            const dow = this.$filter('date')(newDeal.HotelDeal.CheckInDate, 'EEE');
            const delta = newDeal.Price - oldDeal.Price;
            this.analytics.track(
                'mixpanel',
                'HolidayDealsChangedDate',
                {
                    DayOfWeek: dow,
                    Delta: delta
                }
            );
        }

        trackDealEdit(type) {
            if (!this.singleEditTrack[type]) {
                this.analytics.track('mixpanel', `HolidayDealsChanged${type}`);
                this.singleEditTrack[type] = true;
            }
        }

        private _findSelected(deals, preselected) {
            let cheapest;
            for (let i = 0, ii = deals.length; i < ii; i++) {
                // pick perfect selection
                if (preselected && deals[i].DepartureEpoch === preselected.DepartureEpoch) {
                    return deals[i];
                }

                // pick absolute cheapest in the grid
                if (!cheapest || deals[i].Price < cheapest.Price) { cheapest = deals[i]; }
            }
            return cheapest;
        }

        private _sortRoomsByPrice(rooms: any) {
            for (let i = 0, ii = rooms.length; i < ii; i++) {
                const r = rooms[i];
                r.BoardOptions = _.sortBy(r.BoardOptions, (b: any) => b.Cost);
                r.MinCost = r.BoardOptions[0].Cost;
            }
            return _.sortBy(rooms, (r: any) => r.MinCost);
        }

        private _pickBestRoom(
            rooms: any,
            boardTypes: any,
            oldRoom: any,
            oldBt: any,
            persist: boolean
        ) {
            let pRoom;
            let pBoardType;

            if (persist) {
                const persisted = this._persistSelection(rooms, oldRoom, oldBt);
                pRoom = persisted.pRoom;
                pBoardType = persisted.pBoardType;
            }

            if ((!boardTypes || !boardTypes.length) || (pRoom && pBoardType)) {
                return { room: pRoom || rooms[0], bt: pBoardType || rooms[0].BoardOptions[0] };
            }

            let bestSelection;
            for (let i = 0, ii = rooms.length; i < ii; i++) {
                const room = rooms[i];
                for (let j = 0, jj = room.BoardOptions.length; j < jj; j++) {
                    const bt = room.BoardOptions[j];
                    if (boardTypes.indexOf(bt.BoardType) > -1) {
                        if (!bestSelection || bestSelection.bt.Cost > bt.Cost) {
                            bestSelection = { room: pRoom || room, bt };
                        }
                    }
                }
            }

            return bestSelection;
        }

        private _persistSelection(rooms, oldRoom, oldBt) {
            const pRoom = oldRoom
                ? _.find(rooms, (r: any) => r.MasterId === oldRoom)
                : undefined;

            let pBoardType;
            if (pRoom) {
                pBoardType = _.find(pRoom.BoardOptions, (bt: any) => bt.BoardType === oldBt);
            }

            return { pRoom, pBoardType };
        }

        private _calcDifference(priceToCompare, currentPrice, priceMode) {
            let diff = priceToCompare - currentPrice;
            if (priceMode === 0) {
                diff = diff / this.occupancyService.getNumberOfNonInfantPassengers();
            }
            const label = this.$filter('roundedCurrency')(Math.abs(diff));
            return { diff, label };
        }

    }

    angular
        .module('TR')
        .service('dealsBoxService', DealsBoxService);
}
